<div [formGroup]="parentForm">
  <wsd-extended-input label="{{ showLabel ? (label | translate) : '' }}"
                     [control]="parentForm.get(controlName)">
    <p-multiSelect [options]="expertiseItems"
                   [formControlName]="controlName"
                   selectedItemsLabel="{0} items selected"
                   [defaultLabel]="'SELECT_EXPERTISE_AREAS.PLACEHOLDER' | translate"
                   (onChange)="change($event)">
    </p-multiSelect>
  </wsd-extended-input>
</div>
